import ReactDoM from 'react-dom'
import AddOpportunity from '../features/pipeline/AddOpportunity/AddOpportunity.jsx';



function Modal({ open, onClose, save }) {

    if(!open) return null;


  return  ReactDoM.createPortal(
    <>
        <div
            className='fixed inset-0 z-[100] bg-black/20'
            onClick={onClose}
        >
            <div className='modal-content' onClick={(e) => e.stopPropagation()}>
                <AddOpportunity onClose={onClose} save={save} />
            </div>
        </div>

    </>,
    document.getElementById('portal')
  )
}

export default Modal
